import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HeaderConstants } from 'src/app/header.constants';
import { AlarmsService } from 'src/app/service/alarms.service';
import { ExcelService } from 'src/app/service/excel.service';

@Component({
    selector: 'app-routes',
    templateUrl: './routes.component.html',
    styleUrls: ['./routes.component.scss'],
    standalone: false // NOSONAR
})
export class RoutesComponent implements OnInit {

  @Input('alarmRoutes') alarmRoutes: any; // NOSONAR
  @Input('selectedAlarmId') selectedAlarmId: string; // NOSONAR
  columnDefs: any;
  tempData: any;
  gridApi: any;
  gridColumnApi: any
  gridOptions!: GridOptions;
  setPagination = 'true';
  defaultColDef: any;
  paginationPageSize: number = 20;
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  @ViewChild('agGrid', { static: true }) agGrid: any;
  rowData: any; 
  tmpData: any; 
  pipe: any;
  exportRoutesButtonClicked: boolean = false;
  exportMessage: string = '';
  headerList: any;
  headerConstants: HeaderConstants = new HeaderConstants();
	dynamicHeight: number;
	totalRecords = 0; // Replace with your actual total records count
	sRecord = 1;
	eRecord = 1;
	cPage = 1;
	tPage = 0;
	rpPage: any = 20;
	endRecord = 0;
	pgDropDown = [
		{value: 5 , selected : false},
		{value: 10 , selected : false},
		{value: 20 , selected : true},
		{value: 50 , selected : false},
    {value: 'ALL' , selected : false},
	]
  icons: { sortUnSort: string; };

  constructor(private readonly excelService: ExcelService, private readonly ngxUiLoaderService: NgxUiLoaderService, 
    private readonly alarmsService: AlarmsService) {
    this.pipe = new DatePipe('en-US');    
  }

  ngOnInit(): void {      
    this.dynamicHeight = 0.665 * (window.innerHeight) - 55;  
    this.columnDefs = this.headerConstants.getAlarmHeader(this.selectedAlarmId);   
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    }; 
    if (this.alarmRoutes.length) {
      this.totalRecords = this.alarmRoutes.length;
      this.paginationPageSize = this.rpPage !== 'ALL' ? this.paginationPageSize : this.totalRecords;
      this.tPage = this.rpPage !== 'ALL' ? Math.ceil(this.totalRecords / this.rpPage) : 1;
      this.sRecord = 1
      this.eRecord = this.rpPage > this.totalRecords ? this.totalRecords : this.rpPage
      if (this.cPage > this.tPage) {
        this.cPage = 1;
      }
    }
  }

  sizeToFit() { this.gridApi.sizeColumnsToFit(); }

	goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }

	goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }

	goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }

	goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }

  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") // NOSONAR
      {this.gridApi?.setGridOption('paginationPageSize', Number(this.alarmRoutes.length)); this.updatePaginationDetails();}
    else
     { this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value)); this.updatePaginationDetails();}
  }

  getCurrentPage(): boolean {
		if (this.cPage == 1) {  // NOSONAR
			this.currentPageBoolean = true;
		}
		else { this.currentPageBoolean = false; }
		return this.currentPageBoolean;
	}

	isLastPage(): boolean {
		this.currentPageForTotalPage = Number(this.cPage);
		if (this.tPage == this.currentPageForTotalPage) {  // NOSONAR
			this.isLastPageFound = true;
		}
		else {
			this.isLastPageFound = false;
		}
		return this.isLastPageFound;
	}

	rppChanged(event:any) {
		this.cPage = 1;
		event.target.value === 'ALL' ? this.gridApi?.setGridOption('paginationPageSize', this.totalRecords) : this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
		this.updatePaginationDetails();
	}

	updatePaginationDetails() {
		if (this.gridApi) {
			this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
			this.tPage = this.gridApi.paginationGetTotalPages();

			this.sRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + 1
			this.eRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + this.gridApi.paginationGetPageSize()
			this.totalRecords = this.gridApi.paginationGetRowCount();
			this.eRecord = this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
		}
	}

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }

  // exportRoutes() {
  //   this.ngxUiLoaderService.start("loader-01");
  //   this.exportRoutesButtonClicked = true;
  //   this.exportMessage = 'Exporting the selected alarm routes into xlsx file, please wait!';
  //   this.rowData = this.alarmRoutes;
  //   if (this.rowData.length > 0) {
  //     const exportData: any = [];
  //     this.rowData.forEach(element => {
  //       const obj = {
  //         id: element.id,
  //         alarm: element.alarm,
  //         domicile: element.domicile,
  //         puRoute: element.puRoute,
  //         routeDate: this.getDate(element.routeDate),
  //         combinationNumber: element.combinationNumber,
  //         overtime: element.overtime,
  //         logisticsPoint: element.logisticsPoint
  //       };
  //       exportData.push(obj);
  //     });
  //     const headers = ['ID', 'Alarm', 'Domicile', 'Route', 'Route Date', 'Combination No', 'Overtime', 'Logistics Point'];
  //     this.excelService.exportAsExcelFile(exportData, 'Alarm_Routes', headers);
  //   } else {
  //     console.info('Route data length is ZERO');
  //   }
  //   this.exportRoutesButtonClicked = false;
  //   this.exportMessage = '';
  //   this.ngxUiLoaderService.stop("loader-01");
  // }

  getDate(dt: any) {
    return this.pipe.transform(dt, 'MM/dd/yyyy');
  }

}
